// @flow
import { Grid } from 'semantic-ui-react';
import { SelectField } from '@src/formik-utils/FormFields';
import React, { useContext } from 'react';
import { useFormikContext } from 'formik';
import { getDropdownOptions } from '@components/stream-governance/utils';
import { SPUserCommitMetadataContext } from '@streaming-projects/user-commit-details/contexts/SPUserCommitMetadataContext';
import {
  getDimensionsPath,
  getIfGivenRowIsANewlyAddedRow,
} from '@streaming-projects/user-commit-details/committed-capacity/utils';

export const ECKUDimensionColumns = ({ metricIndex, dimensionIndex, row }) => {
  const { setFieldValue, setFieldTouched } = useFormikContext();
  const dimensionsPath = getDimensionsPath(metricIndex, dimensionIndex);
  const providerPath = `${dimensionsPath}.provider`;
  const clusterTypePath = `${dimensionsPath}.cluster_type`;

  const providerColConfig = {
    backendFieldName: 'provider',
    displayNameCol: 'provider_label',
    parentFieldsInGroup: [],
  };

  const clusterTypeColConfig = {
    backendFieldName: 'cluster_type',
    displayNameCol: 'cluster_type_label',
    parentFieldsInGroup: ['provider'],
  };

  const dataUniverse =
    useContext(SPUserCommitMetadataContext)?.committed_cku_capacity_configs ?? [];

  const providerDropDownOptions = getDropdownOptions(
    dataUniverse,
    row,
    providerColConfig,
    false,
    false,
    false,
    true
  );

  const clusterTypeDropDownOptions = getDropdownOptions(
    dataUniverse,
    row,
    clusterTypeColConfig,
    false,
    false,
    false,
    true
  );

  const shouldColumnBeDisabled = !getIfGivenRowIsANewlyAddedRow(row);

  return (
    <>
      <Grid.Column width={3}>
        <SelectField
          addLabel={false}
          disableOnFormErrors={false}
          disabled={shouldColumnBeDisabled}
          fieldDisplayName="Cloud Provider"
          fieldName={providerPath}
          onChange={async () => {
            await setFieldValue(clusterTypePath, null);
            await setFieldTouched(clusterTypePath, true);
          }}
          options={providerDropDownOptions}
        />
      </Grid.Column>
      <Grid.Column width={3}>
        <SelectField
          addLabel={false}
          disableOnFormErrors={false}
          disabled={shouldColumnBeDisabled}
          fieldDisplayName="Cluster SKU"
          fieldName={clusterTypePath}
          options={clusterTypeDropDownOptions}
        />
      </Grid.Column>
    </>
  );
};
